<template>
    <div class="report">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">{{ column }}</div>
            </div>
        </div>
        <el-alert title="暂无报告" :class="showAss" type="error"></el-alert>
        <div class="asstes contianer">
          <div class="item"  v-for="item in combinedArray" :key="item.id">
            <div class="vatar">
              <el-avatar icon="el-icon-user-solid" :size="size" :src="item.user"></el-avatar>
            </div>
            <div class="con">
              <div class="text">
                <div class="name"><span>姓名：</span>{{item.byname}}</div>
                <div class="num"><span>年龄：</span>{{item.age}}</div>
              </div>
              <div class="age">
                <div class="sex"><span>性别：</span>{{item.sex}}</div>
                <el-button type="primary" @click="lookData">查看报告</el-button>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Assesscomp',
  data () {
    return {
      column: '测评完成',
      activeName: 'first',
      size: 'large',
      showAss: 'close',
      inform1: [
        { user: require('@/assets/user_avatar01.png'), byname: '乐乐', sex: '男', age: '5岁10月', status: 0 },
        { user: require('@/assets/user_avatar02.png'), byname: '虫虫', sex: '女', age: '6岁10月', status: 1 },
        { user: require('@/assets/user_avatar03.png'), byname: '乖乖', sex: '男', age: '5岁10月', status: 2 },
        { user: require('@/assets/user_avatar04.png'), byname: '瑶瑶', sex: '女', age: '6岁10月', status: 0 }
      ],
      inform2: [
        { user: require('@/assets/user_avatar05.png'), byname: '小当归', sex: '男', age: '5岁10月', status: 1 },
        { user: require('@/assets/user_avatar06.png'), byname: '小紫荆', sex: '女', age: '6岁10月', status: 0 },
        { user: require('@/assets/user_avatar07.png'), byname: '小蛋挞', sex: '男', age: '5岁10月', status: 2 },
        { user: require('@/assets/user_avatar08.png'), byname: '小脑斧', sex: '女', age: '6岁10月', status: 1 },
        { user: require('@/assets/user_avatar03.png'), byname: '乖乖', sex: '男', age: '5岁10月', status: 0 },
        { user: require('@/assets/user_avatar04.png'), byname: '瑶瑶', sex: '女', age: '6岁10月', status: 1 }
      ],
      inform3: [
        { user: require('@/assets/user_avatar03.png'), byname: '人参', sex: '男', age: '5岁10月', status: 2 },
        { user: require('@/assets/user_avatar05.png'), byname: '草莓', sex: '女', age: '6岁10月', status: 0 },
        { user: require('@/assets/user_avatar07.png'), byname: '烤鸭', sex: '男', age: '5岁10月', status: 0 },
        { user: require('@/assets/user_avatar02.png'), byname: '羊羔', sex: '女', age: '6岁10月', status: 1 },
        { user: require('@/assets/user_avatar03.png'), byname: '乖乖', sex: '男', age: '5岁10月', status: 1 },
        { user: require('@/assets/user_avatar04.png'), byname: '瑶瑶', sex: '女', age: '6岁10月', status: 2 }
      ]
    }
  },
  computed: {
    // 计算属性，用于合并数组
    combinedArray () {
      return [...this.inform1, ...this.inform2, ...this.inform3]
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    lookData () {
      // 查看报告的逻辑
      this.showAss = 'open'
      setTimeout(() => {
        this.showAss = 'close'
      }, 3000)
    }
  },
  created () {
    // 在组件创建时根据查询参数切换选项卡
    const tab = this.$route.query.tab
    if (tab) {
      this.activeName = tab
    }
  },
  watch: {
    '$route.query.tab' (newTab) {
      if (newTab) {
        this.activeName = newTab
      }
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Assesscomp.vue